module.exports = __webpack_public_path__ + "static/img/i404.513afc99.png";